import React from "react";
import { useNavigate } from "react-router-dom";
import {
  Section,
  Container,
  Heading,
  Card,
  CardInner,
  Button,
} from "toddlar-ui";
import HowItWorks from "../components/HowItWorks";
import WhyUseUs from "../components/WhyUseUs";
import { useAuth } from "src/state/auth";

const Landing: React.FC = () => {
  const { token, user } = useAuth();
  const navigate = useNavigate();

  console.log("Render Landing");
  console.log("User", user);

  return (
    <div className="min-h-screen bg-sand-50">
      <Section background="sand">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          <div>
            <Heading size="display" className="text-ink md:leading-[1.05]">
              Rent Toys. Play. Return. Repeat.
            </Heading>
            <Heading as="p" size="lead" className="mt-4 text-ink-muted">
              149 kr/month for 800 points to spend on toys you choose.
            </Heading>
            <div className="mt-8 flex gap-4 justify-center">
              {token ? null : (
                <Button
                  size="large"
                  variant="primary"
                  onClick={() => navigate("/login")}
                >
                  Login
                </Button>
              )}
              <Button
                size="large"
                variant="secondary"
                onClick={() => navigate("/browse")}
              >
                Browse Toys
              </Button>
            </div>
          </div>
          <Card className="md:ml-auto">
            <CardInner className="aspect-[4/3] flex items-center justify-center bg-sand-100">
              <div className="text-ink-muted">
                <img src="/images/logo.png" alt="Toddlar" />
              </div>
            </CardInner>
          </Card>
        </div>
      </Section>

      <HowItWorks />

      <Section>
        <WhyUseUs />
      </Section>

      <Section>
        <Container>
          <Heading size="h2" className="mb-6">
            What parents say
          </Heading>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {[
              {
                quote:
                  "Our kids love choosing new toys every month. It keeps things fresh without clutter.",
                author: "— Mr. Charlton, Järvsö",
              },
              {
                quote:
                  "So easy and sustainable. The cleaning quality is outstanding.",
                author: "— Me, Stockholm",
              },
            ].map((q, idx) => (
              <Card key={idx}>
                <CardInner>
                  <p className="text-ink">{q.quote}</p>
                  <p className="text-ink-muted mt-2 text-sm">{q.author}</p>
                </CardInner>
              </Card>
            ))}
          </div>
        </Container>
      </Section>
    </div>
  );
};

export default Landing;
